export default __webpack_public_path__ + "static/media/SWT1380.34I-35067_-23150_0.359d8b0f.jpg";